import React, { useState, useEffect, useRef } from "react";
import "./BookingForm.css";
import { useNavigate } from 'react-router-dom';
import VideoPage from "../LandingFolder/VideoSection";
import FbBlackIcon from "../../assets/fbBlackIcon.png";
import BlackEnvelopeIcon from "../../assets/blackEnvelopeIcon.png";
import BlackWhatsappIcon from "../../assets/blackWhatsappIcon.png";
import DeleteIcon from "../../assets/deleteIcon.png";
import Header from "../../GeneralComponents/Header";
import Footer from "../../GeneralComponents/Footer";
import Loader from "../../GeneralComponents/Loader";
import { BASE_URL, get, post } from "../../services/Calls";
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { setTimeout } from "node:timers/promises";
const BookingForm = () => {
  const location = useLocation();
  const { sgp } = location.state || {};
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    tripType: "",
    tripId: "",
    selectedTrip: "",
    tripDate: "",
    firstName: "",
    lastName: "",
    mobile: "",
    additionalPhone: "",
    email: "",
    address: "",
    passengers: {},


    benefitType: "",
    discountForFifthPerson: false,
    discountForChildrenAged12To18: false,
    discountForChildrenAged2To11: false,
    singleRoomSupplement: false,
    extraForTwoPeopleInJeep: false,
    extraForThreePeopleInJeep: false,
    requestingDeductibleInsurance: false,
    requirementsNotes: "",




  });
  const [reloadPage, setReloadPage] = useState(true);
  const [passangerError, setpassangerError] = useState(false);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [name]: false });

  };





  const [newpassangersDetail, setNewpassangersDetail] = useState({

    firstName: "",
    lastName: "",
    passportNumber: "",
    mealPreference: "",
    gender: "",
    dateOfBirth: "",
    passportExpiryDate: "",
  })

  const [passangersDetail, setpassangersDetail] = useState([newpassangersDetail])

  function setPassenger(i: any, key: any, e: any) {
    let tempPersionData = [...passangersDetail];
    if (key == 'firstName')
      tempPersionData[i].firstName = e.target.value;
    if (key == 'lastName')
      tempPersionData[i].lastName = e.target.value;
    if (key == 'passportNumber')
      tempPersionData[i].passportNumber = e.target.value;
    if (key == 'mealPreference')
      tempPersionData[i].mealPreference = e.target.value;
    if (key == 'gender')
      tempPersionData[i].gender = e.target.value;
    if (key == 'dateOfBirth')
      tempPersionData[i].dateOfBirth = e.target.value;
    if (key == 'passportExpiryDate')
      tempPersionData[i].passportExpiryDate = e.target.value;

    setpassangersDetail(tempPersionData);
  }

  const [allSGP, setAllSGP] = useState([])


  useEffect(() => {
    getAllSGP();
    if (sgp?.trip?.name) formData.selectedTrip = sgp.trip.name;

    getCountries()
    if (sgp?.trip?.country?.name) {
      formData.tripType = sgp.trip.country.name;
    }
  }, [])

  async function getAllSGP() {
    try {
      const response = await get(BASE_URL + "/self-guided-packages?personalized=false");
      if (response && response.results && response.results.length > 0) {
        setAllSGP(response.results);
      }
    }
    catch (ex) {
      //alert(ex)
      console.log('error', ex)
    }
  }
  const [countriesData, setcountriesData] = useState([]);

  const getCountries = async () => {
    try {
      const response = await get(BASE_URL + '/countries?order=ASC')
      if (response && response.length > 0) {
        setcountriesData(response);

      }
    }
    catch (ex) {
      //alert(ex)
      console.log('error', ex)
    }
  }

  function addNewPassanger() {
    setpassangersDetail([...passangersDetail, {

      firstName: "",
      lastName: "",
      passportNumber: "",
      mealPreference: "",
      gender: "",
      dateOfBirth: "",
      passportExpiryDate: "",
    }]);

  }
  function deletePersion(index: any) {

    const tempPersion: any = [];
    for (let i = 0; i < passangersDetail.length; i++) {
      if (i !== index)
        tempPersion.push(passangersDetail[i])
    }
    setpassangersDetail(tempPersion)
  }











  const [errors, setErrors] = useState({ firstName: false, lastName: false, mobile: false, tripType: false, tripDate: false, additionalPhone: false, email: false, address: false, requirementsNotes: false, selectedTrip: false });
  const firstNameRef = useRef<HTMLInputElement>(null);
  const lastNameRef = useRef<HTMLInputElement>(null);
  const mobileRef = useRef<HTMLInputElement>(null);
  const additionalPhoneRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const addressRef = useRef<HTMLInputElement>(null);
  const requirementsNotesRef = useRef<HTMLTextAreaElement>(null);

  const tripTypeRef = useRef<HTMLSelectElement>(null);
  const selectedTripRef = useRef<HTMLSelectElement>(null);
  const tripDateRef = useRef<HTMLSelectElement>(null);



  async function submit() {
    try {
      const newErrors = {
        firstName: formData.firstName.trim() === '',
        lastName: formData.lastName.trim() === '',
        mobile: formData.mobile.trim() === '',
        additionalPhone: formData.additionalPhone.trim() === '',
        tripType: formData.tripType.trim() === '',
        selectedTrip: formData.tripType.trim() === '',
        tripDate: formData.tripDate.trim() === '',
        email: formData.email.trim() === '',
        address: formData.address.trim() === '',
        requirementsNotes: formData.requirementsNotes.trim() === '',

      };



      setErrors(newErrors);

      // All validations passed

      for (let i = 0; i < passangersDetail.length; i++) {
        const passenger = passangersDetail[i];

        let tempPassangersDetail = [...passangersDetail];
        if (!passenger.firstName) {
          setpassangerError(true);
          return;
        }
        if (!passenger.lastName) {

          setpassangerError(true);
          return;
        }
        if (!passenger.passportNumber) {
          setpassangerError(true);
          return;
        }
        if (!passenger.mealPreference) {
          setpassangerError(true);
          return;
        }
        if (!passenger.gender) {
          setpassangerError(true);
          return;
        }
        if (!passenger.dateOfBirth) {
          setpassangerError(true);
          return;
        }
        if (!passenger.passportExpiryDate) {
          setpassangerError(true);
          return;
        }


      }



      // Focus the first empty field
      if (newErrors.tripType && tripTypeRef.current) {
        tripTypeRef.current.focus();
        return;
      }
      if (newErrors.selectedTrip && selectedTripRef.current) {
        selectedTripRef.current.focus();
        return;
      }
      if (newErrors.tripDate && tripDateRef.current) {
        tripDateRef.current.focus();
        return;
      }
      if (newErrors.firstName && firstNameRef.current) {
        firstNameRef.current.focus();
        return;
      }
      if (newErrors.lastName && lastNameRef.current) {
        lastNameRef.current.focus();
        return;
      }
      if (newErrors.mobile && mobileRef.current) {
        mobileRef.current.focus();
        return;
      }
      if (newErrors.additionalPhone && additionalPhoneRef.current) {
        additionalPhoneRef.current.focus();
        return;
      }
      if (newErrors.email && emailRef.current) {
        emailRef.current.focus();
        return;
      }
      if ((!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) && emailRef.current) {
        emailRef.current.focus();
        return;
      }
      if (newErrors.address && addressRef.current) {
        addressRef.current.focus();
        return;
      }





      /* 
        if (newErrors.benefitType) {
          // Can't focus radio group easily; maybe scroll into view or highlight
          const el = document.querySelector('input[name="benefitType"]:checked') ||
                     document.querySelector('input[name="benefitType"]');
          if (el) (el as HTMLInputElement).focus();
          return;
        } */


      if (newErrors.requirementsNotes && requirementsNotesRef.current) {
        requirementsNotesRef.current.focus();
        return;
      }


      //for passanger validation
      setpassangerError(false);


      if (passangerError) return;
      setpassangerError(false);
      //for passanger validation


      //formData.tripId = sgp.trip.id
      //formData.selectedTrip = sgp.trip.name
      formData.passengers = passangersDetail

      if (formData.discountForFifthPerson) formData.discountForFifthPerson = true;
      else formData.discountForFifthPerson = false;

      if (formData.discountForChildrenAged12To18) formData.discountForChildrenAged12To18 = true;
      else formData.discountForChildrenAged12To18 = false;

      if (formData.discountForChildrenAged2To11) formData.discountForChildrenAged2To11 = true;
      else formData.discountForChildrenAged2To11 = false;

      if (formData.singleRoomSupplement) formData.singleRoomSupplement = true;
      else formData.singleRoomSupplement = false;

      if (formData.extraForTwoPeopleInJeep) formData.extraForTwoPeopleInJeep = true;
      else formData.extraForTwoPeopleInJeep = false;

      if (formData.extraForThreePeopleInJeep) formData.extraForThreePeopleInJeep = true;
      else formData.extraForThreePeopleInJeep = false;

      if (formData.requestingDeductibleInsurance) formData.requestingDeductibleInsurance = true;
      else formData.requestingDeductibleInsurance = false;

const arrivedFrom = localStorage.getItem("arrived_from");
formData.firstName=arrivedFrom
                ? `${formData.firstName} | arrived from ${arrivedFrom}`
                : formData.firstName;



      setLoader(true)
      const response = await post(BASE_URL + '/contact/travel_booking', formData)
      if (response && response.data && response.data.status == 'ok') {


        setLoader(false);
        setFormData({
          tripType: "",
          tripId: "",
          selectedTrip: "",
          tripDate: "",
          firstName: "",
          lastName: "",
          mobile: "",
          additionalPhone: "",
          email: "",
          address: "",
          passengers: {},
          benefitType: "",
          discountForFifthPerson: false,
          discountForChildrenAged12To18: false,
          discountForChildrenAged2To11: false,
          singleRoomSupplement: false,
          extraForTwoPeopleInJeep: false,
          extraForThreePeopleInJeep: false,
          requestingDeductibleInsurance: false,
          requirementsNotes: "",

        })

        setpassangersDetail([{
          firstName: "",
          lastName: "",
          passportNumber: "",
          mealPreference: "",
          gender: "",
          dateOfBirth: "",
          passportExpiryDate: "",
        }]);


        setReloadPage(false);
        toast.success('Your Request submited successfully.', {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        window.setTimeout(() => {
          setReloadPage(true);
        }, 500);

      }
      else {
        setLoader(false);

      }
    }
    catch (e) {
      setLoader(false);
    }

  }


  return (
    <div>
      <Header />
      <VideoPage pageFrom={'register'} countryname={""} />
      <div className="destinationPathRow" id='registerPageId'>
        <div className="destinationPaginationDiv">
          <span className="destinationPaginationHome" onClick={() => { navigate('/') }}>Home</span>
          <span className="destinationPaginationBorder"></span>
          <span className="destinationPaginationCountry">Contact Us</span>
        </div>
         <div className="destinationSocialIconDiv">
                        <a href="https://www.facebook.com/profile.php?id=61576034056586" target="_blank" >
                            <img  className="destinationSocialFbIcon" src={FbBlackIcon} /></a>
                          
                            <a href="mailto:info@medraft.co.il"><img  className="destinationSocialMailIcon" src={BlackEnvelopeIcon} /></a>
                            <a href="https://wa.me/9720542927253" target="_blank" rel="noopener  noreferrer" > <img className="destinationSocialWhatsAppIcon" src={BlackWhatsappIcon} /></a>
                        </div>
      </div>
      {reloadPage &&
        <div className="form-container">
          <h2>Travel Booking Form</h2>

          <div className="form-grid">
            <div className="left-column">
              <div className="section">
                <h3>Trip Details/Itinerary</h3>
                <select name="tripType" value={formData.tripType} style={{ border: errors.tripType ? '2px solid red' : '', }} ref={tripTypeRef} onChange={handleChange}>
                  <option value="">Select Destinations</option>



                  {countriesData.map((country: any, index) => (
                    country?.name &&
                    <option value={country.name}>{country.name} </option>
                  ))}

                </select>
                <select name="selectedTrip" value={formData.selectedTrip} onChange={handleChange} style={{ border: errors.selectedTrip ? '2px solid red' : '', }} ref={selectedTripRef}>
                  <option value="">Select Trip </option>
                  {/*  <option value={sgp.trip.name} >{sgp.trip.name} </option>
                */}

                  {allSGP.map((sgp1: any, index) => (
                    sgp1?.trip?.name && sgp1?.trip?.country?.name && (sgp1?.trip?.country?.name == formData.tripType || formData.tripType == "") &&
                    <option value={sgp1.trip.name}>{sgp1.trip.name} </option>
                  ))}
                </select>


                <select name="tripDate" ref={tripDateRef} style={{ border: errors.tripDate ? '2px solid red' : '', }} onChange={handleChange} id="sel_date" required>
                  <option value="">Select a date...</option>
                  <option value="2025-05-21">21.05.2025</option>
                  <option value="2025-06-18">18.06.2025</option>
                  <option value="2025-06-25">25.06.2025</option>
                  <option value="2025-07-02">02.07.2025</option>
                  <option value="2025-09-10">10.09.2025</option>
                  <option value="2025-10-03">03.10.2025</option>
                </select>
              </div>


              <div className="section">
                <h3>Personal Details</h3>
                <input type="text" ref={firstNameRef} name="firstName" placeholder="First Name" onChange={handleChange} style={{ border: errors.firstName ? '2px solid red' : '', }} />
                <input type="text" ref={lastNameRef} name="lastName" placeholder="Last Name" onChange={handleChange} style={{ border: errors.lastName ? '2px solid red' : '', }} />
                <input type="text" ref={mobileRef} name="mobile" placeholder="Mobile" onChange={handleChange} style={{ border: errors.mobile ? '2px solid red' : '', }} />

                <input type="text" ref={additionalPhoneRef} name="additionalPhone" placeholder="Additional Phone" onChange={handleChange} style={{ border: errors.additionalPhone ? '2px solid red' : '', }} />


                <input type="email" ref={emailRef} name="email" placeholder="Email" onChange={handleChange} style={{ border: errors.email ? '2px solid red' : '', }} />

                <input type="text" ref={addressRef} name="address" placeholder="Address" onChange={handleChange} style={{ border: errors.address ? '2px solid red' : '', }} />
              </div>

            </div>






            <div className="right-column">

              {/* <div className="section">
              <h3>Benefits</h3>
              
              <div className="form-grid" style={{ border: errors.benefitType ? '2px solid red' : 'none', padding: '10px',fontSize: 13 }}>
                <div className="left-column">


                  <label><input type="radio" className="radiobutton" name="benefitType" value="MEDRAFT Customer Returns" onChange={handleChange} /> Customer Returns</label><br />
                  <label><input type="radio" className="radiobutton" name="benefitType" value="friendClub" onChange={handleChange} /> Friend Club</label>
                </div>

                <div className="right-column">

                  <label><input type="radio" className="radiobutton" name="benefitType" value="histadrut" onChange={handleChange} /> Histadrut/Teachers' Organization</label>
                  <label><input type="radio" className="radiobutton" name="benefitType" value="policeFund" onChange={handleChange} /> Police Officers' Fund</label>
                </div>

              </div>

            </div> */}





              <div className="section">
                <h3>Discounts</h3>
                <div className="form-grid" style={{ fontSize: 13 }}>
                  <div className="left-column">

                    <label><input type="checkbox" className="radiobutton" name="discountForFifthPerson" onChange={handleChange} /> Discount for a fifth person in a SUV</label>

                    <label><input type="checkbox" className="radiobutton" name="discountForChildrenAged12To18" onChange={handleChange} />Discount for children aged 12-18</label>
                  </div>

                  <div className="right-column">
                    <label><input type="checkbox" className="radiobutton" name="discountForChildrenAged2To11" onChange={handleChange} /> Discount for children aged 2-11</label>
                  </div>
                </div>
              </div>


              <div className="section">
                <h3>Extras</h3>
                <div className="form-grid" style={{ fontSize: 13 }}>
                  <div className="left-column">
                    <label><input type="checkbox" className="radiobutton" name="singleRoomSupplement" onChange={handleChange} />Single room supplement</label>
                    <label><input type="checkbox" className="radiobutton" onChange={handleChange} name="extraForTwoPeopleInJeep" />Extra for two people in a SUV</label>
                  </div>
                  <div className="right-column">

                    <label><input type="checkbox" className="radiobutton" name="extraForThreePeopleInJeep" onChange={handleChange} /> Extra for three people in a SUV</label>

                    <label><input type="checkbox" style={{ flex: 1 }} className="radiobutton" name="requestingDeductibleInsurance" onChange={handleChange} /> Requesting deductible reimbursement insurance on the SUV.</label>

                  </div>
                </div>
              </div>


              <div className="section">
                <h3>Requirements/Notes</h3>
                <textarea ref={requirementsNotesRef} name="requirementsNotes" onChange={handleChange} style={{ width: '100%', height: 300, border: errors.requirementsNotes ? '2px solid red' : '' }} />
              </div>

            </div>
          </div>






          <div className="section">
            <h3>Passenger Details</h3>

            {passangersDetail.map((passanger, index) => (

              <div className="form-grid" style={{ fontSize: 12 }}>
                <div style={{ width: '100%' }}>
                  <input type="text" name={'fname' + index} placeholder="First Name " onChange={(e) => { setPassenger(index, 'firstName', e) }} value={passanger.firstName} style={{ border: (passangerError && !passangersDetail[index].firstName) ? '2px solid red' : '' }} />
                  <p className="inputDescription">According to the passport</p>

                </div>

                <div style={{ width: '100%' }}>
                  <input type="text" name={'lname' + index} placeholder="Last Name " onChange={(e) => { setPassenger(index, 'lastName', e) }} value={passanger.lastName} style={{ border: (passangerError && !passangersDetail[index].lastName) ? '2px solid red' : '' }} />
                  <p className="inputDescription">According to the passport</p>
                </div>


                <div style={{ width: '100%' }}>
                  <input type="text" name={"passportNumber" + index} placeholder="Passport Number" onChange={(e) => { setPassenger(index, 'passportNumber', e) }} value={passanger.passportNumber} style={{ border: (passangerError && !passangersDetail[index].passportNumber) ? '2px solid red' : '' }} />
                  <p className="inputDescription"></p>
                </div>

                <div style={{ width: '100%' }}>
                  <select name={"mealPreference" + index} value={passanger.mealPreference || ""} onChange={(e) => { setPassenger(index, 'mealPreference', e) }} style={{ border: (passangerError && !passangersDetail[index].mealPreference) ? '2px solid red' : '' }} >
                    <option value="">Select meal </option>
                    <option value="Regular">Regular</option>
                    <option value="Vegetarian">Vegetarian</option>
                  </select>
                  <p className="inputDescription"></p>
                </div>


                <div style={{ width: '100%' }}>
                  <select name={"gender" + index} value={passanger.gender || ""} onChange={(e) => { setPassenger(index, 'gender', e) }} style={{ border: (passangerError && !passangersDetail[index].gender) ? '2px solid red' : '' }}>
                    <option value="">Select Gender </option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                  <p className="inputDescription"></p>
                </div>


                <div>
                  <input type="date" placeholder="Date of Birth" name={"dateOfBirth" + index} value={passanger.dateOfBirth || ""} onChange={(e) => { setPassenger(index, 'dateOfBirth', e) }} style={{ border: (passangerError && !passangersDetail[index].dateOfBirth) ? '2px solid red' : '' }} />
                  <p className="inputDescription">Date Of Birth</p>
                </div>
                <div>
                  <input type="date" placeholder="Passport Expiry" name={"passportExpiryDate" + index} value={passanger.passportExpiryDate || ""} onChange={(e) => { setPassenger(index, 'passportExpiryDate', e) }} style={{ border: (passangerError && !passangersDetail[index].passportExpiryDate) ? '2px solid red' : '' }} />
                  <p className="inputDescription">Passport Expiry Date</p>
                </div>
                {index > 0 &&
                  <img className="destinationSocialWhatsAppIcon" style={{ marginTop: 20, cursor: 'pointer' }} src={DeleteIcon} alt="WhatsApp" onClick={() => { deletePersion(index) }} />
                }
                {index == 0 &&
                  <div style={{ minWidth: 20 }}></div>
                }

              </div>
            ))}

            <button className="submitButton" onClick={addNewPassanger} type="button">Add another Persion</button>
          </div>



<div className="payment-container">
  <h2 className="payment-title">Payment details and terms</h2>

  <div className="payment-content">
    {/* Left Side */}
    <div className="left-column">
      <div className="section">
        <h3 className="section-title">Payment method</h3>
        <ul className="section-list">
          <li>The first payment will be charged by credit card.</li>
          <li>Remaining payments deducted ~1 month before departure.</li>
          <li>Bank transfer/cash allowed up to 60 days before trip.</li>
          <li>If unpaid, credit card will be auto-charged on the 3rd.</li>
        </ul>
     {/*  </div>

      <div className="section"> */}
        <h3 className="section-title">Bank transfer</h3>
        <ul className="section-list">
          <li>Medraft | Mizrahi Bank | Branch 528 | Account No. 164212</li>
          <li>Send confirmation via email or fax to 03-5783434</li>
          <li>Credit card details must be deposited until transfer is complete.</li>
        </ul>
     {/*  </div>

      <div className="section"> */}
        <h3 className="section-title">Payment terms</h3>
        <ul className="section-list">
          <li>Cancellation - 29 business days: refund (except €120).</li>
          <li>Flight payment per airline conditions.</li>
          <li>Cash payment at Medraft office, Caesarea, Sun–Thu, 9:30AM–5:00PM.</li>
          <li>Foreign currency billed by exchange rate at time of billing.</li>
          <li>Trip price may update due to tax or policy changes.</li>
          <li>Manual vehicles default; automatic on approval.</li>
        </ul>
      </div>
    </div>

    {/* Right Side */}
    <div className="right-column">
      <div className="section">
        <h3 className="section-title">Cancellation fee conditions</h3>
        <ul className="section-list">
          <li>15-29 business days before departure – 35% of the trip cost.</li>
          <li>4-14 business days before departure – 65% of the trip cost.</li>
          <li>3 business days or less, or no-show – 100% of the trip cost.</li>
          <li>Flight cancellation depends on airline policy.</li>
        </ul>
      </div>
    </div>
  </div>

  <p className="footer-note">
    After receiving the registration form, a MEDRAFT representative will contact you to finalize the account and obtain credit information.
  </p>
</div>


          
          <div style={{ textAlign: 'center' }}>
            <button className="submitButton" onClick={submit} type="submit">Submit</button>
          </div>
        </div>
      }
      <div style={{ height: '6.625vw' }}></div>
      {loader && <Loader />}
      <Footer />
    </div>
  );
};

export default BookingForm;
